module.exports = __webpack_public_path__ + "img/zhonghai.b80eae09.png";